// client/src/components/ticketing/MyTicket.jsx
//
// Post-purchase confirmation screen, shown inline on the landing page right
// after TicketPurchasePanel's purchase-confirm succeeds. Lists each issued
// ticket with a badge-PDF download link (the PDF itself embeds the QR code
// — see server/services/ticketPdfService.js) — no separate QR-image
// endpoint needed for this.

import React from 'react';

export default function MyTicket({ tenantId, tickets = [], pendingWebhook, onBuyMore, hideBuyMore = false }) {
  const badgeUrl = (qrToken) => `/api/ticketing/${tenantId}/ticket/${qrToken}/badge-pdf`;

  return (
    <div className="mt-4 rounded-xl border border-black/10 dark:border-white/10 p-4">
      {pendingWebhook ? (
        <p className="text-amber-600 dark:text-amber-400 font-semibold mb-3">
          Payment succeeded — your tickets are being processed. They'll also be emailed to you shortly.
        </p>
      ) : (
        <p className="text-emerald-600 dark:text-emerald-400 font-semibold mb-3">
          You're registered! {tickets.length} ticket{tickets.length === 1 ? '' : 's'} confirmed.
        </p>
      )}

      {tickets.length > 0 && (
        <ul className="space-y-2 mb-3">
          {tickets.map((ticket, idx) => (
            <li
              key={ticket.id}
              className="flex items-center justify-between gap-3 rounded-lg border border-black/10 dark:border-white/10 p-3 text-sm"
            >
              <span>Ticket {idx + 1}</span>
              <a
                href={badgeUrl(ticket.qr_token)}
                target="_blank"
                rel="noreferrer"
                className="px-3 py-1.5 rounded bg-cobalt text-white text-sm font-medium"
              >
                Download PDF
              </a>
            </li>
          ))}
        </ul>
      )}

      <p className="text-xs opacity-60 mb-3">
        A confirmation email with your ticket{tickets.length === 1 ? '' : 's'} is on its way to your inbox.
      </p>

      {!hideBuyMore && (
        <button type="button" onClick={onBuyMore} className="w-full px-3 py-2 rounded border text-sm">
          Buy more tickets
        </button>
      )}
    </div>
  );
}
